export default __webpack_public_path__ + "static/media/crush-image.ea78f6ee.png";